import config from 'config';
import { get, httpDelete, post, put } from 'api/client';
import {
  LinkSource,
  ShortenLink,
  ShortenLinkDetail,
} from 'types/LinkShortener';
import { getExtendedTimeout } from '../utils/request';

export type CreateShortLinkInput = {
  id?: string;
  _id?: string;
  pageId?: string | null;
  name?: string;
  url: string;
  note?: string | null;
  source?: LinkSource;
  customSlug?: string | null;
  isCopied?: boolean;
  saveToList?: boolean;
};

const API_CONFIG = {
  baseURL: config.API_SERVICE_ENDPOINT,
};

export const LinkShortenerApi = {
  allLinks(variables: { pageIds?: string[] | null }) {
    return get<ShortenLink[]>('/link-shortener/links', {
      ...API_CONFIG,
      timeout: getExtendedTimeout(1),
      params: variables.pageIds ? { pageIds: variables.pageIds } : undefined,
    });
  },
  save(input: CreateShortLinkInput, requestConfig?: { skipAuth?: boolean }) {
    if (requestConfig?.skipAuth) {
      return post<ShortenLink>(
        '/link-shortener/links',
        { url: input.url },
        {
          baseURL: config.PUBLIC_API_SERVICE_ENDPOINT,
        },
      );
    }

    if (input.id) {
      return put<ShortenLink>(
        `/link-shortener/links/${input.id}`,
        {
          url: input.url,
          name: input.name,
          pageId: input.pageId,
          source: input.source,
          note: input.note,
        },
        API_CONFIG,
      );
    }

    return post<ShortenLink>(
      '/link-shortener/links',
      {
        url: input.url,
        name: input.name,
        pageId: input.pageId,
        customSlug: input.customSlug,
        isCopied: input.isCopied,
        saveToList: input.saveToList,
      },
      API_CONFIG,
    );
  },
  delete(params: { id: string; source: LinkSource }) {
    return httpDelete(`/link-shortener/links/${params.id}`, {
      ...API_CONFIG,
      params: { source: params.source },
    });
  },
  detail(id: string, source: LinkSource) {
    return get<ShortenLinkDetail>(`/link-shortener/links/${id}`, {
      ...API_CONFIG,
      params: { source },
    });
  },
};
